import request from '../utils/request'
export default class SystemApi {
    static selectWithClassifyKey = (params) => {
        return request.post('/sw-sewage/api/0/dict/selectWithClassifyKey', params)
    }

    // 摄像头播放接口
    static play = (params) => {
        return request.post('/system/0/media/play', params)
    }
}
